module.exports = __webpack_public_path__ + "img/Logo_TCORP_150.e5293e1e.png";